export interface SliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
}

export function Slider({ label, value, onChange }: SliderProps) {
  return (
    <div className="flex flex-col items-center">
      <label className="text-white mb-0">{label}</label>
      <input
        type="range"
        min="0"
        max="100"
        step="20"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(Number(e.target.value))}
        className="w-24"
      />
    </div>
  );
}
